export default __webpack_public_path__ + "static/media/barra.2598a536.png";